const config = {
  apiGateway: {
    URL: "https://lu6i5d4q5m.execute-api.ca-central-1.amazonaws.com/v1/",
    AUTH: "https://wg5rkd5hh4.execute-api.ca-central-1.amazonaws.com/v1/",
    REGION: "ca-central-1"
  },
  defaultLanguage: "fr",
  sso_enabled: true,
  sso_config: {
            auth_url: "fer-prod.auth.ca-central-1.amazoncognito.com",
            identity_provider: "FER-PROD-AD",
            scope: "openid+aws.cognito.signin.user.admin",
            grant_type: "authorization_code",
            client_id: "3mrsqdub5ibvluea61b9s9saa3",
            redirect_uri: "https://foureyes.ferique.com/authorize",
        },
  dast_config: {enabled: false},
  canadaPostApiKey: "GR51-PG39-NZ69-MP35",
  fef_ui_version: "2.0.63-tier2"
}

var siteConfig = {
  title: "SIF Conformité",
  fourlyticsId: false,
  fourlyticsScreenRecording: false
};

var componentConfig = {
  
};

export {config, siteConfig, componentConfig}
